import templateUrl from "emun.order/parts/parts-order-details.htm";
import controller from "emun.order/parts/parts-order-details.controller";

export default {
  bindings: {
    orderId: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
